import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getIn, useFormikContext } from 'formik'

import { Address } from '../models/address.model'
import { resetAddressAction, setAddressAction } from '../store/address.reducer'
import { selectAddressByType } from '../store/address.selectors'

import { AddressesOptions, AddressType } from '~/address/models/address.model'
import { RootState } from '~/core/store/root.reducer'
import useValidateForm from '~/sale/hooks/useValidateForm'
import { setFormValidity } from '~/sale/store'

export default function useAddress(id: string, addressType: AddressType) {
  const dispatch = useDispatch()
  const { values, isValid } = useFormikContext<Address>()

  const address = useSelector((state: RootState) => selectAddressByType(state, id, addressType))

  const addressOwner = getIn(values, 'addressOwner')
  const data = address?.data
  const loading = address?.loading
  const { number, letter, floor, province, town, postalCode, otherInfo } = values

  useValidateForm({
    lineId: id,
    form: 'address',
    isValidForm: addressOwner === AddressesOptions.SAME || isValid,
    refreshValue: addressOwner,
  })

  useEffect(() => {
    return () => {
      dispatch(setFormValidity({ lineId: id, form: 'address', isValid: true }))
    }
  }, [])

  function setAddress(_address: Address) {
    dispatch(setAddressAction({ id, addressType, address: _address }))
  }

  function resetAddress() {
    dispatch(resetAddressAction({ id, addressType }))
  }

  useEffect(() => {
    if (
      addressOwner !== AddressesOptions.SAME &&
      (!!number || !!letter || !!floor || !!province || !!town || !!postalCode || !!otherInfo)
    ) {
      dispatch(setAddressAction({ id, addressType, address: { ...data, ...values } }))
    }
    // eslint-disable-next-line
  }, [number, letter, floor, province, town, postalCode, otherInfo])

  return {
    address: data,
    addressOwner,
    loading,
    setAddress,
    resetAddress,
  }
}
